import { Fragment } from "react";
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Header from "~/components/Header";
import Menu from "~/components/Menu";
import Content from "~/components/Content";
import CookieBar from "~/components/CookieBar";
import ScrollToTop from '~/components/ScrollToTop';
import Redirect from '~/components/Redirect';
import RedirectHomePage from '~/components/RedirectHomePage';

import HomePage from "~/pages/HomePage";

import { ALL_LANGS, ROUTES } from '~/const';
import { setSeo } from "~/providers/lang";
import { loadScript } from "~/utils/utils";

import ContactsPage from "~/pages/ContactsPage";
import WeddingPage from "~/pages/WeddingPage";
import SchoolWeddingPage from "~/pages/SchoolWeddingPage";
import ActionPage from "~/pages/ActionPage";
import FormalPage from "~/pages/FormalPage";
import OurCommodityPage from "~/pages/OurCommodityPage";
import GalleriesPage from "~/pages/GalleriesPage";
import GalleryWeddingPage from "~/pages/GalleryWeddingPage";
import GallerySchoolWeddingPage from "~/pages/GallerySchoolWeddingPage";
import GalleryActionPage from "~/pages/GalleryActionPage";
import GalleryAddonsPage from "~/pages/GalleryAddonsPage";
import GalleryFormalPage from "~/pages/GalleryFormalPage";
import GalleryShopPage from "~/pages/GalleryShopPage";
import GdprPage from "~/pages/GdprPage";
import UploadPage from "~/pages/UploadPage";
import Page404 from "~/pages/Page404";
import EditPage from "./pages/EditPage";

import { mainStore } from "./stores/main";

import './index.less';

async function main() {
	// @ts-expect-error load
	const { PAGE_DATA } = await import(/* webpackChunkName: "pagedata" */ `~/data/pagedata`);

	// @ts-expect-error typ
	mainStore.getState().setPageData(PAGE_DATA);
	setSeo();

	const container = document.getElementById('app') || document.body;
	const root = createRoot(container);

	function onConfirm() {
		/* eslint-disable camelcase */
		window.seznam_retargeting_id = 122709;

		loadScript("//c.imedia.cz/js/retargeting.js");
		loadScript("https://www.googletagmanager.com/gtag/js?id=G-ZJFV76WZF4", () => {
			/* eslint-disable */
			window.dataLayer = window.dataLayer || [];
			// @ts-expect-error typ
			function gtag(){dataLayer.push(arguments);}
			// @ts-expect-error typ
			gtag("js", new Date());
			// @ts-expect-error typ
			gtag("config", "G-ZJFV76WZF4");
		});
	}

	function getLangRoutes(lang: string) {
		return <Fragment key={`main-route-lang-${lang}`}>
			<Route key={`lang-route-${lang}`} path={ROUTES.contacts[lang]} element={<ContactsPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.wedding[lang]} element={<WeddingPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.schoolWedding[lang]} element={<SchoolWeddingPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.action[lang]} element={<ActionPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.formal[lang]} element={<FormalPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.ourCommodity[lang]} element={<OurCommodityPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.galeries[lang]} element={<GalleriesPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.galleryWedding[lang]} element={<GalleryWeddingPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.gallerySchoolWedding[lang]} element={<GallerySchoolWeddingPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.galleryAction[lang]} element={<GalleryActionPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.galleryAddons[lang]} element={<GalleryAddonsPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.galleryFormal[lang]} element={<GalleryFormalPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.galleryShop[lang]} element={<GalleryShopPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.gdpr[lang]} element={<GdprPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.upload[lang]} element={<UploadPage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.page404[lang]} element={<Page404 />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.home[lang]} element={<HomePage />} />
			<Route key={`lang-route-${lang}`} path={ROUTES.edit[lang]} element={<EditPage />} />
		</Fragment>;
	}

	// render
	root.render(
		<Router>
			<ScrollToTop />
			<Header>
				<Menu />
			</Header>
			<Content>
				<Routes>
					<Route key="main-index" index element={<RedirectHomePage />} />
					<Route path=":lang">
						{ ALL_LANGS.map(lang => getLangRoutes(lang)) }
						<Route key="route-index" index element={<Redirect />} />
						<Route path="*" element={<Redirect />} />
					</Route>
				</Routes>
			</Content>
			<CookieBar onConfirm={onConfirm} />
		</Router>,
	);
}

main();
